<template>
    <div>
        <div class="row">
            <div class="column small-7">
                <PageTitle title="Toegangsautorisaties" :total="total" :loading="loading" />
            </div>
            <div class="column small-5 text-right">
                <b-button type="is-light" @click="checkConnection">Test connectie</b-button>
                <b-button type="is-primary" tag="router-link" to="/panel/connect/nieuw">Toegang aanmaken</b-button>
            </div>
        </div>

        <!-- <div class="row">
            <div class="column">
                <b-button type="is-success" @click="connect">Verbinden</b-button>

                <div class="messages">
                    <h3>Berichten:</h3>
                    <hr>
                    {{ messages }}
                </div>
            </div>
        </div> -->

        <ConnectionModal
            ref="ConnectionModal"
            embedded_from="ConnectOverview"
            :organisationId="user.role != 'pit' && user.organisation ? user.organisation : null"
            @connectionSuccesful="connectionSuccesful"
        />

        <div class="row">
            <div class="column">
                <ConnectTable
                    ref="ConnectTable"
                    @passTotal="passTotal"
                    @passLoading="passLoading"
                />
            </div>
        </div>

        <div class="row">
            <div class="column">
                <ConnectDownload />
            </div>
        </div>
    </div>
</template>

<script>
import ConnectionModal from './ConnectionModal'
import ConnectDownload from './ConnectDownload'
import ConnectTable from './components/ConnectTable'

export default {
    name: 'ConnectOverview',

    components: {
        ConnectionModal,
        ConnectTable,
        ConnectDownload
    },

    data() {
        return {
            total: null,
            loading: false
        }
    },

    computed: {
        user() {
            return this.$store.state.user
        },

        showActive() {
            return this.$store.state.showActive
        }
    },

    methods: {
        checkConnection() {
            this.$refs['ConnectionModal'].checkConnection().then((res) => {
                if (res == 'connection_success') {
                    setTimeout(() => {
                        this.$refs['ConnectionModal'].toggleModal()
                    }, 2000)
                }
            }).catch((e) => {
                if (e == 'no_connection') {
                    setTimeout(() => {
                        this.$refs['ConnectionModal'].toggleModal()
                    }, 2000)
                }
            })
        },

        passTotal(total) {
            this.total = total
        },

        passLoading(loading) {
            this.loading = loading
        },

        connectionSuccesful() {
            if (this.user.role == 'pit') {
                setTimeout(() => {
                    this.$refs['ConnectionModal'].toggleModal()
                }, 2000)
            }
        }
    },

    watch: {
        showActive(newVal, oldVal){
            if(newVal !== oldVal){
                this.$refs['ConnectTable'].loadAsyncData()
            }
        }
    }
}
</script>